import React from 'react';
import Skeleton from '../ui/Skeleton';

/**
 * Skeleton loading component for dashboard statistics
 */
function DashboardSkeleton() {
  return (
    <div className="space-y-6">
      {/* Header skeleton */}
      <div className="flex justify-between items-center">
        <Skeleton width="180px" height="2rem" />
        <Skeleton width="120px" height="2rem" />
      </div>
      
      {/* Stat cards skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {Array.from({ length: 4 }).map((_, index) => (
          <StatCardSkeleton key={index} />
        ))}
      </div>
      
      {/* Charts skeleton */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow-sm p-6">
          <Skeleton width="180px" height="1.5rem" className="mb-4" />
          <Skeleton height="250px" className="rounded-md" />
        </div>
        <div className="bg-white rounded-lg shadow-sm p-6">
          <Skeleton width="180px" height="1.5rem" className="mb-4" />
          <Skeleton height="250px" className="rounded-md" />
        </div>
      </div>
      
      {/* Activity and quick actions skeleton */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white rounded-lg shadow-sm p-6">
          <Skeleton width="180px" height="1.5rem" className="mb-4" />
          <div className="space-y-3">
            {Array.from({ length: 5 }).map((_, index) => (
              <ActivityItemSkeleton key={index} />
            ))}
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm p-6">
          <Skeleton width="180px" height="1.5rem" className="mb-4" />
          <div className="space-y-3">
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton key={index} width="100%" height="2.5rem" className="rounded-md" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * Skeleton for stats card
 */
function StatCardSkeleton() {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 flex flex-col">
      <div className="flex items-center justify-between mb-3">
        <Skeleton width="120px" height="1.25rem" />
        <Skeleton.Circle size="2rem" />
      </div>
      <Skeleton width="40%" height="2rem" className="mb-2" />
      <div className="flex items-center mt-auto">
        <Skeleton width="80px" height="1rem" />
      </div>
    </div>
  );
}

/**
 * Skeleton for activity item
 */
function ActivityItemSkeleton() {
  return (
    <div className="flex items-start p-3 border-b last:border-0">
      <Skeleton.Circle size="2.5rem" className="mr-3" />
      <div className="flex-1">
        <Skeleton width="60%" height="1.25rem" className="mb-1" />
        <Skeleton width="80%" height="1rem" className="mb-1" />
        <Skeleton width="40%" height="0.875rem" />
      </div>
    </div>
  );
}

/**
 * Skeleton for chart components
 */
DashboardSkeleton.Chart = function ChartSkeleton({ height = "300px" }) {
  return (
    <div className="w-full">
      <Skeleton width="120px" height="1.25rem" className="mb-3" />
      <Skeleton height={height} className="rounded-md" />
    </div>
  );
};

export default DashboardSkeleton;